import createURLParams from './createURLParams';

/**
 * Pobiera lub wysyła informacje oraz parsuje odpowiedź z JSON-a.
 * @param url - Adres docelowy
 * @param options - obiekt z opcjami przekazywanymi do wywołania fetch
 */
const jsonFetch = async <T>(
	url: string,
	options: Omit<RequestInit, 'body'> & {
		body?: object;
		query?: Record<string, string | number | boolean | undefined>;
		returnResponse?: boolean;
	} = {},
): Promise<T & { response: Response }> => {
	const {
		body, query, returnResponse, ...rest
	} = options;
	const targetOptions: RequestInit = { ...rest };

	if (body) {
		targetOptions.body = JSON.stringify(options.body);
		targetOptions.headers = {
			'Content-Type': 'application/json',
			...options.headers,
		};
	}

	const search = query ? createURLParams(query).toString() : '';
	const response = await fetch(`${url}${search.length > 0 ? `?${search}` : ''}`, targetOptions);

	if (!response.ok) {
		const error = { ...response, data: await response.json() };
		throw error;
	}

	try {
		const data = await response.json();
		if (returnResponse) {
			return { ...data, response };
		}
		return data;
	} catch (error) {
		console.warn(`Response from ${url} was not a valid JSON`);
		return { response };
	}
};

export default jsonFetch;
